import { aggregateSessionPathsWorkingTreeStatus } from '../../../git/status/index.js';
import type { SessionWorktreeCache } from '../session-worktree-cache.js';
import { resolveCommitTargetsAsync } from '../resolve-commit-targets.js';
import type { SessionDiscover } from './types.js';

export async function getSessionWorkingTreeStatus(
  cache: SessionWorktreeCache,
  sessionId: string,
  discover: SessionDiscover,
): Promise<{
  hasUncommittedChanges: boolean;
  hasUnpushedCommits: boolean;
  uncommittedFileCount: number;
}> {
  return aggregateSessionPathsWorkingTreeStatus(
    await resolveCommitTargetsAsync(sessionId, cache, discover),
  );
}
